<template>
  <CRow>
    <CCol lg="4" md="5" sm="12" class="d-flex align-items-center mt-2">
      <multiselect
        class="d-inline-block multiselect--custom z4"
        v-model="customFieldSelected"
        :multiple="false"
        :options="customTypes"
        :customLabel="customLabel"
        custom
        style="max-width: 250px; z-index: 5"
        ref="textAreaCustom"
        :allow-empty="false"
        :show-labels="false"
        placeholder="Search or choose"
      >
      </multiselect>
      <CButton style="height: 40px" class="ml-2 px-3" :disabled="!customFieldSelected" color="primary" @click="addCustomFieldsToText">{{
        $t('contactField.buttom-add')
      }}</CButton>
    </CCol>
    <CCol md="5" sm="12">
      <div class="d-inline-flex flex-column form-group">
        <label> {{ $t('contactField.label-unsubscribe') }} </label>
        <CButton style="height: 40px" class="px-4 text-uppercase" color="white" @click="addSubscribeText">
          {{ $t('contactField.buttom-unsubscribe') }}</CButton
        >
      </div>
    </CCol>
  </CRow>
</template>

<script>
import services from '@/services.js'
const CUSTOM_GROUP = 'CUSTOM'

export default {
  name: 'ImporHTML',
  data() {
    return {
      messages: [],
      customTypes2: null,
      customTypes: [],
      templateName: '',
      textMessage: '',
      customFieldSelected: null,
    }
  },

  mounted() {
    this.getSchema()
  },

  methods: {
    async getSchema() {
      try {
        const FIELD_TYPES = await services.fieldtypes(this.$store.state.auth.organizationId)

        const SCHEME = await services.audienceSchema(this.$store.state.auth.organizationId)

        if (SCHEME.data.data.errorCode === 1000) {
          this.customTypes = [...this.handleCustomtypes(FIELD_TYPES)]
          return
        }

        this.customTypes = [...SCHEME.data.data.values, ...this.handleCustomtypes(FIELD_TYPES)]
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || 'Error',
        })
      }
    },

    customLabel(option) {
      return `${option.value}`
    },

    handleCustomtypes(FIELD_TYPES) {
      let CUSTOMS = FIELD_TYPES.data.data.groups.filter(group => group.group == CUSTOM_GROUP)

      if (CUSTOMS[0].types.lenght) {
        return CUSTOMS.map((item, index) => {
          return {
            ...item.types[index],
            value: item.types[index].personalizationTag,
          }
        })
      }

      return []
    },

    addCustomFieldsToText() {
      this.$emit('addCustomFieldsToText', this.customFieldSelected.personalizationTag)
    },

    addSubscribeText() {
      let text = `${this.$t('templates.general.fields.textUnsubscribe')} <a target="_black" href="${this.$t(
        'templates.general.fields.unsubscribe',
      )}">${this.$t('templates.general.fields.textLinkUnsubscribe')}</a>`

      this.$emit('addSubscribeText', text)
    },
  },
}
</script>

<style></style>
